<template>
    <v-card>
        <v-card-title class="border-bottom py-2">
            <div class="font-size-16 black--text">
                <v-icon class="mr-2" small>mdi-tune-variant</v-icon> Filter
            </div>

            <v-spacer />

            <v-btn icon @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
            <div>
                <label> Mapel </label>
                <v-select
                    dense
                    v-model="form.mapel_id"
                    :items="mapelList"
                    outlined
                    item-text="nama"
                    item-value="id"
                    class="mt-1"
                    clearable
                    placeholder="Pilih Mata Pelajaran"
                >
                </v-select>
            </div>

            <div>
                <label> Dari Tanggal </label>
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="form.date_from"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_from"
                            outlined
                            dense
                            readonly
                            placeholder="Masukan Tanggal"
                            v-bind="attrs"
                            v-on="on"
                            clearable
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_from" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(form.date_from)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>

            <div>
                <label> Sampai Tanggal </label>
                <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="form.date_to"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_to"
                            outlined
                            dense
                            readonly
                            clearable
                            placeholder="Masukan Tanggal"
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_to" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu2 = false">
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(form.date_to)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
        </v-card-text>

        <v-card-actions class="pt-0">
            <v-spacer />
            <v-btn depressed @click="clear()" class="mr-1"> Reset </v-btn>
            <v-btn depressed color="primary" @click="search()">
                Cari
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "dialog-filter-activity",
    data() {
        return {
            loading: false,
            menu: false,
            menu2: false,
            data: [],
            mapel: [],
            mapelList: JSON.parse(localStorage.getItem("mapels")),
            form: {
                mapel_id: null,
                date_from: null,
                date_to: null,
            },
        };
    },

    mounted() {},

    watch: {},

    methods: {
        search() {
            this.$emit("search", this.form);
        },

        clear() {
            this.form = {};
            this.$emit("search", this.form);
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogFilterActivity.vue?d361a464